import { createToolMatcher } from '@/lib/utils/tool-matcher';

import type { ToolCallMessagePart } from '@assistant-ui/react';

export function isTextPart(part: unknown): part is { type: 'text'; text: string } {
  return typeof part === 'object' && part !== null && (part as { type: string }).type === 'text';
}

export function isToolCallPart(part: unknown): part is ToolCallMessagePart {
  return (
    typeof part === 'object' &&
    part !== null &&
    'type' in part &&
    (part as { type: string }).type === 'tool-call'
  );
}

export function isRunning(part: { status?: { type: string } }): boolean {
  return part.status?.type === 'running';
}

// Mastra-internal tool whose calls are noise to the user — validator failures
// are recoverable (model retries with corrected args) and successful writes are
// background bookkeeping. Suppressed from the activity trail and the generic
// MessageError UI.
const matchSuppressedTool = createToolMatcher('updateWorkingMemory');
export function isSuppressedTool(toolName: string): boolean {
  return matchSuppressedTool(toolName);
}

// Keep in lockstep with its three consumers: activity-trail, use-tool-group-state and
// should-render-message-error. Any string counts because Mastra persists a thrown tool call as
// `state: 'result'` whose result is the bare error message — no flag, no error shape.
export function isErrorResult(result: unknown): boolean {
  if (typeof result === 'string') return true;
  if (typeof result !== 'object' || result === null) return false;
  if ((result as { isError?: unknown }).isError === true) return true;
  // The shape both the live AI-SDK adapter and the platform history mapper give an output-error.
  return Boolean((result as { error?: unknown }).error);
}
